// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import Router from 'react-router-dom/BrowserRouter';
import { Provider } from 'react-intl-redux';

import 'normalize.css/normalize.css';
import 'react-dynamic-swiper/lib/styles.css';

import './index.css';

import configureStore from './redux/configureStore';

import App from './components/App';

require('viewport-units-buggyfill').init();

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js